import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from './../../actions'
import SelectBed from './../../components/site/select_bed'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectBed: state.searchFormCondition.selectBed,
})

const SelectBedContainer = connect(mapStateToProps, mapDispatchToProps)(SelectBed)

export default SelectBedContainer
